import { render, staticRenderFns } from "./productivity.vue?vue&type=template&id=2bb26a04&scoped=true&"
import script from "./productivity.vue?vue&type=script&lang=js&"
export * from "./productivity.vue?vue&type=script&lang=js&"
import style0 from "./productivity.vue?vue&type=style&index=0&id=2bb26a04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb26a04",
  null
  
)

export default component.exports